'use client';

import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { FAQItem } from '../../../data/faqData';

interface FAQSectionProps {
  faqItems: FAQItem[];
  defaultOpenIndex?: number | null;
}

export function FAQSection({ faqItems, defaultOpenIndex = null }: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpenIndex);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="px-3 xs:px-4 sm:px-6 md:px-8 py-8 xs:py-10 sm:py-12 md:py-16 lg:py-20 bg-white mx-2 sm:mx-4 lg:mx-8">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-8 xs:mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-[#1D2125]">
            Frequently asked questions (FAQs)
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3 xs:space-y-4">
          {faqItems.map((faq, index) => (
            <div
              key={index}
              className="bg-[#F5F8F9] rounded-xl overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-4 xs:px-5 sm:px-6 py-4 xs:py-4.5 sm:py-5 text-left flex items-center justify-between transition-colors"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm xs:text-base sm:text-lg font-semibold text-[#1D2125] pr-3 xs:pr-4">
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <Minus className="h-4 xs:h-4.5 sm:h-5 w-4 xs:w-4.5 sm:w-5 text-[#0D373D] flex-shrink-0" />
                ) : (
                  <Plus className="h-4 xs:h-4.5 sm:h-5 w-4 xs:w-4.5 sm:w-5 text-[#0D373D] flex-shrink-0" />
                )}
              </button>
              {openIndex === index && (
                <>
                  <div className="border-t border-gray-300 mx-4 xs:mx-5 sm:mx-6"></div>
                  <div className="px-4 xs:px-5 sm:px-6 pb-4 xs:pb-5 sm:pb-6 pt-3 xs:pt-3.5 sm:pt-4">
                    <p className="text-xs xs:text-sm sm:text-base text-[#4D4F52] leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

